var installedModules = {};
var moduleToHandlerMapping = {
	63609: {
		getter: () => (() => (__webpack_require__(68559))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	91558: {
		getter: () => (() => (__webpack_require__(57055))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	34162: {
		getter: () => (() => (__webpack_require__(8504))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	91479: {
		getter: () => (() => (__webpack_require__(60316))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	52917: {
		getter: () => (() => (__webpack_require__(74646))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/core",
	},
	80352: {
		getter: () => (() => (__webpack_require__(31398))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk",
	},
	94969: {
		getter: () => (() => (__webpack_require__(34456))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/forms",
	},
	75667: {
		getter: () => (() => (__webpack_require__(68824))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	33952: {
		getter: () => (() => (__webpack_require__(80436))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	886: {
		getter: () => (() => (__webpack_require__(3758))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "graphql",
	},
	48263: {
		getter: () => (() => (__webpack_require__(49066))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@apollo/client/core",
	},
	7087: {
		getter: () => (__webpack_require__.e(8994).then(() => (() => (__webpack_require__(38994))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "graphql-types",
	},
	24480: {
		getter: () => (() => (__webpack_require__(7797))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "apollo-angular",
	},
	1803: {
		getter: () => (() => (__webpack_require__(95072))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	34975: {
		getter: () => (() => (__webpack_require__(42880))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@progress/kendo-angular-grid",
	},
	2263: {
		getter: () => (Promise.all([__webpack_require__.e(7087), __webpack_require__.e(9545), __webpack_require__.e(861)]).then(() => (() => (__webpack_require__(10861))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "shared-utils",
	},
	94115: {
		getter: () => (Promise.all([__webpack_require__.e(4480), __webpack_require__.e(1803), __webpack_require__.e(2263), __webpack_require__.e(3497), __webpack_require__.e(5114), __webpack_require__.e(377)]).then(() => (() => (__webpack_require__(29912))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "shared-auth",
	},
	11391: {
		getter: () => (__webpack_require__.e(3820).then(() => (() => (__webpack_require__(13820))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "gizmo-web-layout",
	},
	29461: {
		getter: () => (__webpack_require__.e(8371).then(() => (() => (__webpack_require__(58371))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "shared-nomenclature",
	},
	35123: {
		getter: () => (() => (__webpack_require__(79771))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/autocomplete",
	},
	44177: {
		getter: () => (__webpack_require__.e(7260).then(() => (() => (__webpack_require__(27260))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@gizmo/ui-grid",
	},
	71815: {
		getter: () => (() => (__webpack_require__(12587))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/dialog",
	},
	71883: {
		getter: () => (Promise.all([__webpack_require__.e(7336), __webpack_require__.e(330), __webpack_require__.e(943), __webpack_require__.e(4095), __webpack_require__.e(3573), __webpack_require__.e(2474), __webpack_require__.e(3707), __webpack_require__.e(7087), __webpack_require__.e(4480), __webpack_require__.e(1803), __webpack_require__.e(9545), __webpack_require__.e(353), __webpack_require__.e(3452), __webpack_require__.e(9689), __webpack_require__.e(2263), __webpack_require__.e(4051), __webpack_require__.e(3497), __webpack_require__.e(4523), __webpack_require__.e(4541), __webpack_require__.e(6370)]).then(() => (() => (__webpack_require__(16370))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "shared-ui",
	},
	10785: {
		getter: () => (__webpack_require__.e(3900).then(() => (() => (__webpack_require__(33900))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "gizmo-web-shared-ui",
	},
	13518: {
		getter: () => (__webpack_require__.e(5229).then(() => (() => (__webpack_require__(15229))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@apollo/client/link/ws",
	},
	22944: {
		getter: () => (__webpack_require__.e(7687).then(() => (() => (__webpack_require__(47687))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@apollo/client/link/error",
	},
	48676: {
		getter: () => (__webpack_require__.e(7768).then(() => (() => (__webpack_require__(97768))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@apollo/client/link/batch",
	},
	99495: {
		getter: () => (__webpack_require__.e(5498).then(() => (() => (__webpack_require__(75498))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "gizmo-web-pages",
	}
};
var initialConsumes = [63609,91558,34162,91479,52917,80352,94969,75667,33952,886,48263,63609,91558,34162,91479,52917,80352,94969,75667,33952,886,48263,63609,91558,34162,91479,52917,80352,94969,75667,33952,886,48263];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"1803": [
		1803
	],
	"1869": [
		63609,
		91558,
		34162,
		91479,
		52917,
		80352,
		94969,
		75667,
		33952,
		886,
		48263
	],
	"1883": [
		71883
	],
	"2263": [
		2263
	],
	"2772": [
		10785,
		13518,
		22944,
		48676,
		99495
	],
	"3452": [
		34975
	],
	"3461": [
		63609,
		91558,
		34162,
		91479,
		52917,
		80352,
		94969,
		75667,
		33952,
		886,
		48263
	],
	"4051": [
		11391,
		29461,
		35123,
		44177,
		71815
	],
	"4115": [
		94115
	],
	"4480": [
		24480
	],
	"7087": [
		7087
	],
	"8792": [
		63609,
		91558,
		34162,
		91479,
		52917,
		80352,
		94969,
		75667,
		33952,
		886,
		48263
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}